(function () {
    angular
        .module('advancedapp')
        .component('mediaCoverage', {
            restrict: 'E',
            bindings: {
                results: '<',
                showmore: '@',
                limit: '<'
            },
            template: require('./media-coverage.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = [];

    function controller() {

        var vm = this;
        var limit = 10;

        vm.showmoreResult = function () {
            vm.limit = vm.limit + 10;
        };
    }
})();